import React from "react";

const Testimonial = () => {
  return (
    <div className="testimonial">
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="text-center">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Testimonial
            </h6>
            <h1 className="mb-5">Our Students Say!</h1>
          </div>
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-8 mx-auto">
                <div
                  id="myCarousel"
                  className="carousel slide"
                  data-ride="carousel"
                >
                  <ol className="carousel-indicators">
                    <li
                      data-target="#myCarousel"
                      data-slide-to="0"
                      className="active"
                    ></li>
                    <li data-target="#myCarousel" data-slide-to="1"></li>
                    <li data-target="#myCarousel" data-slide-to="2"></li>
                  </ol>

                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="img-box">
                        <img
                          src="img/testimonials/1234-BANDARU LOKESWAR.jpg"
                          alt=""
                        />
                      </div>
                      <p className="testimonial">
                        "Joining Diksha SEA was one of the best decisions I’ve
                        ever made! The courses are comprehensive, the trainers
                        are highly skilled, and the hands-on learning experience
                        made it easy to grasp complex concepts. The supportive
                        environment and personalized attention helped me build
                        confidence and excel in my field. Thanks to DikshaSea, I
                        am now well-equipped to achieve my career goals!"
                      </p>
                      <p className="overview">
                        <b>LOKESWAR</b>, Power BI
                      </p>
                    </div>
                    <div className="carousel-item">
                      <div className="img-box">
                        <img
                          src="img/testimonials/1238-NIKHIL KUMAR .jpg"
                          alt=""
                        />
                      </div>
                      <p className="testimonial">
                        "The training at Diksha SEA was truly transformative.
                        The instructors were experts in their fields, always
                        approachable, and made even the toughest topics easy to
                        understand. The practical assignments and real-world
                        examples helped me gain the skills I needed to succeed.
                        I highly recommend DikshaSea to anyone looking to boost
                        their career!"
                      </p>
                      <p className="overview">
                        <b>NIKHIL </b>, Devops
                      </p>
                    </div>
                    <div className="carousel-item">
                      <div className="img-box">
                        <img
                          src="img/testimonials/1241-SUDHEER KUMAR.jpg"
                          alt=""
                        />
                      </div>
                      <p className="testimonial">
                        "I am incredibly grateful for the exceptional guidance I
                        received at Diksha SEA. The courses were
                        well-structured, and the curriculum was up-to-date with
                        industry standards. The institute not only provided me
                        with technical expertise but also instilled the
                        confidence to take on challenging projects. Thanks to
                        their training, I’ve landed my dream job!".
                      </p>
                      <p className="overview">
                        <b>SUDHEER</b>, Data Scientist
                      </p>
                    </div>
                    <div className="carousel-item">
                      <div className="img-box">
                        <img
                          src="img/testimonials/1253-DILEEP UPPALAPATI.jpg"
                          alt=""
                        />
                      </div>
                      <p className="testimonial">
                        "I am beyond thankful for the incredible support and
                        training I received at Diksha SEA. The courses were
                        thoughtfully designed, and the curriculum aligned
                        perfectly with current industry demands. The instructors
                        were knowledgeable and approachable, making complex
                        concepts easy to grasp. Along with technical skills, the
                        institute helped me build the confidence and
                        problem-solving mindset needed to excel in my career.
                        Thanks to Diksha SEA, I am now thriving in a role I’ve
                        always aspired to achieve!".
                      </p>
                      <p className="overview">
                        <b>DILEEP</b>, Flutter
                      </p>
                    </div>
                    <div className="carousel-item">
                      <div className="img-box">
                        <img
                          src="img/testimonials/1242-KANKALAPATI MAMATHA.jpg"
                          alt=""
                        />
                      </div>
                      <p className="testimonial">
                        "Diksha SEA has been a transformative experience for me.
                        The courses were meticulously planned, combining
                        practical applications with the latest industry trends.
                        The trainers were incredibly supportive, ensuring every
                        concept was crystal clear. Beyond the technical skills,
                        they nurtured my professional growth and boosted my
                        confidence. Thanks to their comprehensive guidance, I
                        have secured an amazing job that perfectly aligns with
                        my career goals. I couldn’t be more grateful!".
                      </p>
                      <p className="overview">
                        <b>Mamatha</b>, Web Development
                      </p>
                    </div>
                  </div>

                  <a
                    className="carousel-control-prev"
                    href="#myCarousel"
                    data-slide="prev"
                  >
                    <i className="fa fa-angle-left"></i>
                  </a>
                  <a
                    className="carousel-control-next"
                    href="#myCarousel"
                    data-slide="next"
                  >
                    <i className="fa fa-angle-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
